import axios from "axios";
import React from 'react';
import {basicAuthHeader} from "./auth-service";

export async function getSpecialAdaptations(){
    const response = await axios.get(process.env.REACT_APP_IP + '/special_adaptations',{
        auth: basicAuthHeader()
    });
    return response.data;
}